import getScrollParent from "scrollparent";
// it is technically possible to make scrollbars even wider, but IMO we shouldn't support it
export const SAFE_SCROLLBAR_HEIGHT = 64;
export const getStickerState = ({ ghost, positionParent, horizontalScrollParent, verticalScrollParent }) => {
    const ghostRectGlobal = ghost.getBoundingClientRect();
    const positionParentRectGlobal = positionParent.getBoundingClientRect();
    const horizontalScrollParentRectGlobal = horizontalScrollParent.getBoundingClientRect();
    /** split into its own commit */
    const verticalScrollParentRect = verticalScrollParent
        ? verticalScrollParent.getBoundingClientRect()
        : {
            x: 0,
            y: 0,
            top: 0,
            bottom: window.innerHeight,
            left: 0,
            right: window.innerWidth,
            width: window.innerWidth,
            height: window.innerHeight
        };
    const ghostRect = getRelativeDOMRect(verticalScrollParentRect, ghostRectGlobal);
    const positionParentRect = getRelativeDOMRect(verticalScrollParentRect, positionParentRectGlobal);
    const horizontalScrollParentRect = getRelativeDOMRect(verticalScrollParentRect, horizontalScrollParentRectGlobal);
    const isPositionParentOnScreen = positionParentRectGlobal.bottom >= verticalScrollParentRect.top &&
        positionParentRectGlobal.top <= verticalScrollParentRect.bottom;
    const canCalculateScrollBarHeight = horizontalScrollParent.offsetHeight + SAFE_SCROLLBAR_HEIGHT >= horizontalScrollParent.scrollHeight;
    const horizontalScrollBarHeight = canCalculateScrollBarHeight &&
        Math.round(horizontalScrollParent.scrollWidth) > Math.round(horizontalScrollParent.clientWidth)
        ? horizontalScrollParent.offsetHeight - horizontalScrollParent.scrollHeight
        : 0;
    return {
        ghostRect,
        positionParentRect,
        horizontalScrollParentRect,
        horizontalScrollBarHeight,
        verticalScrollParentRect,
        isPositionParentOnScreen
    };
};
export const horizontallyIntersects = (stickerA, stickerB) => {
    const rect1 = {
        left: Math.max(stickerA.horizontalScrollParentRect.left, stickerA.ghostRect.left),
        width: Math.min(stickerA.horizontalScrollParentRect.width, stickerA.ghostRect.width)
    };
    const rect2 = {
        left: Math.max(stickerB.horizontalScrollParentRect.left, stickerB.ghostRect.left),
        width: Math.min(stickerB.horizontalScrollParentRect.width, stickerB.ghostRect.width)
    };
    return rect1.left < rect2.left + rect2.width && rect1.left + rect1.width > rect2.left;
};
export const getSmartOffset = (stickers, sticker) => stickers.reduce((offset, thisSticker) => {
    if (thisSticker.isDisabled ||
        thisSticker.isExcludedFromOffsets ||
        thisSticker.isOverlay ||
        thisSticker.ghostRect.top === sticker.ghostRect.top ||
        !thisSticker.isPositionParentOnScreen ||
        thisSticker.positionParentRect.bottom < sticker.ghostRect.top ||
        !horizontallyIntersects(sticker, thisSticker)) {
        return offset;
    }
    return offset + thisSticker.ghostRect.height;
}, 0);
export const getRelativeDOMRect = (scrollableRect, childRect) => {
    const relativeLeft = childRect.left - scrollableRect.left;
    const relativeTop = childRect.top - scrollableRect.top;
    const x = relativeLeft;
    const left = x;
    const y = relativeTop;
    const top = y;
    const relativeRect = {
        x,
        y,
        width: childRect.width,
        height: childRect.height,
        top,
        right: x + childRect.width,
        bottom: y + childRect.height,
        left
    };
    return relativeRect; // missing toJSON() but shouldn't be a problem
};
export const getHorizontalScrollParent = (el) => {
    // getScrollParent always returns an element when an element is passed,
    // and ghost always here defined. So casting as HTMLElement is correct.
    const parent = getScrollParent(el);
    // TODO: fix issues with containers not allowing _horizontal_ scroll while allowing vertical
    return parent;
};
